import React, { useEffect, useState, useCallback } from 'react';
import { Button, Form, Input, Select, message } from 'antd';
import { getMandateStatus, getMstSourceMapping, saveSourceConfigURLMapping } from 'api/nach';
import { NachWebhookDashboardRequestPayload } from 'api/nach';
import { NachWebhookDashboardResponse } from 'api/nach';
import Applevellist from '../WebhookUrlList/Index';

const { Option } = Select;

const Filter: React.FC = () => {
  const [form] = Form.useForm();
  const [sourceApps, setSourceApps] = useState<NachWebhookDashboardResponse[]>([]);
  const [mandateStatuses, setMandateStatuses] = useState<NachWebhookDashboardResponse[]>([]);
  const isAdmin = sessionStorage.getItem('isAdmin');
  const [listKey, setListKey] = useState(0);
  const localUserId = sessionStorage.getItem('userId');
  const userId = Number(localUserId);

  useEffect(() => {
    const fetchData = async () => {
      try {
        debugger;
        const resSourceApps = await getMstSourceMapping({ pageNo: 1 });
        if (resSourceApps.data?.data) {
          setSourceApps(resSourceApps.data.data);
        }
        const resMandateStatuses = await getMandateStatus({ pageNo: 1 });
        if (resMandateStatuses.data?.data) {
          setMandateStatuses(resMandateStatuses.data.data);
        }
      } catch (err) {
        console.error('Error loading initial data:', err);
        message.error('Failed to load initial data.');
      }
    };

    fetchData();
  }, []);

  const handleSubmit = useCallback(
    async (values: { sourceId: string; mandateStatus: string[]; customerUrl: string }) => {
      const statusIdList = values.mandateStatus
        .map((status) => {
          const selectedStatusObject = mandateStatuses.find(
            (statusObj) => statusObj.status === status
          );
          return selectedStatusObject ? selectedStatusObject.statusId : null;
        })
        .filter((id): id is number => id !== null); // Filter out any null values

      const payload: NachWebhookDashboardRequestPayload = {
        sourceId: values.sourceId,
        statusIdList: statusIdList,
        configURL: values.customerUrl,
        userId: userId,
      };

      try {
        await saveSourceConfigURLMapping(payload);

        message.success('Configurations saved successfully.');
        form.resetFields();
        setListKey((prevKey) => prevKey + 1);
      } catch (err) {
        message.error('Failed to save configurations.');
      }
    },
    [form, mandateStatuses]
  );

  // const handleSubmit = useCallback(
  //   async (values: { sourceId: string; mandateStatus: string; customerUrl: string }) => {
  //     debugger;
  //     const selectedStatusObject = mandateStatuses.find(
  //       (statusObj) => statusObj.status === values.mandateStatus
  //     );
  //     if (!selectedStatusObject) {
  //       message.error('Selected mandate status not found. Please try again.');
  //       return;
  //     }
  //     const payload: NachWebhookDashboardRequestPayload = {
  //       sourceId: values.sourceId,
  //       statusId: selectedStatusObject.statusId,
  //       status: values.mandateStatus,
  //       configURL: values.customerUrl,
  //     };

  //     try {
  //       debugger;
  //       await saveSourceConfigURLMapping(payload);
  //       message.success('Configuration saved successfully.');
  //       form.resetFields();
  //       setListKey((prevKey) => prevKey + 1);
  //     } catch (err) {
  //       console.error('Save failed:', err);
  //       message.error('Failed to save configuration.');
  //     }
  //   },
  //   [form, mandateStatuses]
  // );

  const handleClear = useCallback(() => {
    form.resetFields();
  }, [form]);

  return (
    <div className="container">
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{
          sourceId: isAdmin === 'true' ? undefined : sessionStorage.getItem('source'),
        }}
      >
        <Form.Item
          label="Source Application Name"
          name="sourceId"
          rules={[{ required: true, message: 'Please select source application' }]}
        >
          <Select placeholder="Select source application" size="large">
            {sourceApps.map((app) => (
              <Option key={app.sourceId} value={app.sourceId}>
                {app.sourceApplicationName}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Mandate Status"
          name="mandateStatus"
          rules={[{ required: true, message: 'Please select mandate status' }]}
        >
          <Select placeholder="Select mandate status" size="large" mode="multiple">
            {mandateStatuses.map((mandateStatus) => (
              <Option key={mandateStatus.statusId} value={mandateStatus.status}>
                {mandateStatus.status}
              </Option>
            ))}
          </Select>
        </Form.Item>

        {/* <Form.Item
          label="Mandate Status"
          name="mandateStatus"
          rules={[{ required: true, message: 'Please select mandate status' }]}
        >
          <Select placeholder="Select mandate status" size="large" mode="multiple">
            {mandateStatuses.map((status) => (
              <Option key={status} value={status}>
                {status}
              </Option>
            ))}
          </Select>
        </Form.Item> */}

        <Form.Item
          label="Customer URL"
          name="customerUrl"
          rules={[
            { required: true, message: 'Please enter customer URL' },
            { type: 'url', message: 'Please enter a valid URL' },
          ]}
        >
          <Input placeholder="Enter Customer URL" size="large" />
        </Form.Item>

        <Form.Item>
          <Button type="default" onClick={handleClear} style={{ marginRight: '8px' }}>
            Clear
          </Button>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </Form.Item>
      </Form>
      <div style={{ marginTop: '20px' }}>
        <Applevellist key={listKey} />
      </div>
    </div>
  );
};

export default Filter;
